export default {
  Option: {
    ChoosePaperSize: "Chọn khổ giấy",
    ChooseTemplateTem: "Chọn mẫu tem",
    ChangePageSize: "Tùy chỉnh giấy in",
  },
  BarCodeResource: {
    Demo: "Xem trước khi in",
    TemPrint: "Tem in",
    TemSize: "Kích thước tem",
    GetDefault: "Lấy lại mặc định",
    ListTemplate: "Danh sách mẫu",
    MarginSize: "Căn lề khổ giấy (mm)",
    Top: "Trên",
    Bottom: "Dưới",
    Left: "Trái",
    Right: "Phải",
    Space: "Khoảng cách cột, hàng (mm)",
    SpaceCol: "Khoảng giữa các cột",
    SpaceRow: "Khoảng giữa các hàng",
    ResetDefault: "Lấy lại mặc định",
    TemplateName: "Tên mẫu",
    Info: "Thông tin hiển thị",
    Logo: "Logo hiển thị",
    Edit: "Sửa mẫu tem",
    Duplicate: "Nhân bản mẫu tem",
    Save: "Lưu",
    List: "Danh sách mẫu tem",
    LogoShow: "Logo hiển thị",
    DeleteConfirm: "Bạn có chắc chắn muốn xóa mẫu tem không?",
    WarningChoosePageType: "Cần chọn khổ giấy trước",
  },
};
